/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PoComboFilter, PoComboOption } from '@po-ui/ng-components';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGenericListAPI } from '../interfaces/IGenericListAPI';

@Injectable({
  providedIn: 'root'
})
export class StatesService implements PoComboFilter {
  readonly url = `${environment.url}api/framework/v1/genericList`;
  currentyFilter = '';
  constructor(protected http: HttpClient) { }
  getListOfStates(page: number, pageSize: number, uf: string, name?: string): Observable<IGenericListAPI> {
    let filter = `x5_tabela eq '12'`;

    if (name) {
      filter += `and ( x5_chave eq '${uf}' or contains(x5_descri, '${name}'))`;
    } else if (uf) {
      filter += `and x5_chave eq '${uf}'`;
    }

    const params = new HttpParams()
      .append('alias', 'SX5')
      .append('fields', 'x5_chave, x5_descri')
      .append('filter', filter)
      .append('page', page)
      .append('pageSize', pageSize);

    return this.http.get<IGenericListAPI>(this.url, { params });
  }

  getFilteredData(params: any): Observable<PoComboOption[]> {
    this.currentyFilter = params.value !== this.currentyFilter && params.page === 1 ? params.value.toString() : this.currentyFilter;
    return this.getListOfStates(params.page, params.pageSize, this.currentyFilter, this.currentyFilter).pipe(
      map(states =>
        states.items.map(state => ({
          value: state.x5_chave,
          label: state.x5_descri
        }))
      )
    );
  }

  getObjectByValue(value: string): Observable<PoComboOption> {
    return this.getListOfStates(1, 1, value).pipe(
      map(states =>
        states.items.map(state => ({
          value: state.x5_chave,
          label: state.x5_descri
        }))
      ),
      map(states => states[0])
    );
  }
}
